/**
 * Magnesium Insights — production video.
 *
 * The footage is silent b-roll, so it plays while it is on screen and pauses
 * when it scrolls away rather than asking for a tap. The markup ships with
 * native controls so the video is operable with JS off; those are removed only
 * once this script has actually taken over playback.
 *
 * Reduced-motion readers, browsers without IntersectionObserver, and any
 * autoplay the browser refuses all keep the controls and play on demand.
 */
(function () {
  var sections = document.querySelectorAll(".mivid");
  if (!sections.length) return;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var hasObserver = "IntersectionObserver" in window;

  for (var i = 0; i < sections.length; i += 1) {
    setUp(sections[i].querySelector("video"));
  }

  function setUp(video) {
    if (!video || reduce || !hasObserver) return;

    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          var played = video.play();
          // A refused autoplay hands the video back to the reader.
          if (played && played.catch) {
            played.catch(function () {
              video.controls = true;
              observer.disconnect();
            });
          }
        } else {
          video.pause();
        }
      },
      { threshold: 0.35 },
    );

    video.controls = false;
    observer.observe(video);
  }
})();
